import React from 'react';
import DivSX, { DivSXProps } from 'tradevan-ui/@emotion/DivSX';
import { classCombine } from 'tradevan-ui/consts';

const TbSingleRwd = (props: DivSXProps): JSX.Element => {
  const { className, children, ...other } = props;
  return (
    <DivSX className={classCombine(`tb-single-rwd`, className)} {...other}>
      {children}
    </DivSX>
  );
};

export default TbSingleRwd;
